import clsx from 'clsx';
import { Skeleton } from '@/components/ui/skeleton';
import { LoadingIcon } from '@/icons';

const VisualSkeleton = ({ height, className }: { height: number; className?: string }) => {
  return (
    <Skeleton
      className={clsx('flex w-full flex-col items-center justify-center rounded-t-none rounded-b-md', className)}
      style={{ height: `${height}px` }}
    >
      <LoadingIcon />
      <span className='mt-4 text-sm'>Laddar</span>
    </Skeleton>
  );
};

export default VisualSkeleton;
